import axios from 'axios';
import store from '../store';
import router from '../router/index'
import {Dialog} from 'vant';
import { Locale } from 'vant';
import enUS from 'vant/es/locale/lang/en-US';

Locale.use('en-US', enUS);

// switch the environment
// if (process.env.NODE_ENV == 'development') {    
//     axios.defaults.baseURL = 'https://127.0.0.1:8000/';} 
// else if (process.env.NODE_ENV == 'debug') {    
//     axios.defaults.baseURL = 'https://testing.tripleasuperdigital.com';
// } 
// else if (process.env.NODE_ENV == 'production') {    
//     axios.defaults.baseURL = 'https://www.tripleasuperdigital.com';
// }


//redirect to login page
const toLogin = () => {
    router.replace({
        path: '/login',        
        query: {
            redirect: router.currentRoute.fullPath
        }
    });
}

const errorHandle = (status, data) => {
    //check jwt token
    if(data.includes('IdcsException')){
        store.dispatch('showmodal')
    } 
    switch (status) {
        // 401,403: unauthorized/token expired
        case 401 || 403:
            console.log('401/403')
            // Dialog.alert({
            //     message: 'Your login has expired. Please logon again to continue.',
            // }).then(() => {
            // store.dispatch('logout');
            //     toLogin();
            
            // })
            break;
        // 404: request does not exist
        case 404:
            console.log('404')
            // tip('The request does not exist.'); 
            break;
        default:
            console.log(data.message);   
    }
   
}


// create an axios instance
let instance = axios.create({
    timeout: 1000 * 120,
    // headers: {'Authorization':'JWT '+ store.state.token}
});
// set the post header
// instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

//axios request interceptor
instance.interceptors.request.use(    
    config => {        
        const token = store.state.token;        
        token && (config.headers.Authorization = token); 
        return config;    
    },    
    error => Promise.error(error))

// axios response interceptor
instance.interceptors.response.use(    
    //200: success
    res => res.status === 200 ? Promise.resolve(res) : Promise.reject(res),    
    //failed
    error => {
        const { response } = error;
        if (response) {
            // request has been sent but not 200
            errorHandle(response.status, response.data);
            return Promise.reject(response);
        } else {
            // handle errors when network disconnected
            // if (!window.navigator.onLine) {
            //    store.commit('changeNetwork', false);
            // } else {
                return Promise.reject(error);
            }
        }
    );

export default instance;

  
